import $ from 'jquery';

import PageLoadHook from '../core/PageLoadHook';
import WindowFrame from './WindowFrame';
import UptimeClock from './UptimeClock';
import UIElement from './UIElement';
import NavMenu from './NavMenu';
import DesktopManager from './DesktopManager';

export default class UIManager extends PageLoadHook {
  private _uiElements: UIElement[] = [];

  private _desktopManager: DesktopManager;

  constructor(desktopManager: DesktopManager) {
    super();
    this._desktopManager = desktopManager;
  }

  public override onPageLoad() {
    this.initElementsOfType(WindowFrame, this._desktopManager);
    this.initElementsOfType(NavMenu, this._desktopManager);
    this.initElementsOfType(UptimeClock);

    console.debug(
      'Found and initialized %d total UI elements.',
      this._uiElements.length,
    );
  }

  private initElementsOfType<ElemT extends UIElement>(
    ElemClass: {
      Selector: string;
      new (...args: any[]): ElemT;
    },
    ...args: any[]
  ) {
    console.debug('Initializing %s(s)...', ElemClass.name);

    const elements: UIElement[] = $(ElemClass.Selector)
      .map((_: number, elem: HTMLElement) => {
        const newElem = new ElemClass(elem, ...args);
        newElem.mount();
        return newElem;
      })
      .get();

    this._uiElements.push(...elements);

    console.debug(
      'Found and initialized %d %s(s).',
      elements.length,
      ElemClass.name,
    );
  }
}
